import React, { useContext } from 'react';
import { CXContext } from "./cxContext";
import { TagChart }  from "./tagChart";

const TagList = () => {
  const context = useContext(CXContext);
  const ndx = context.ndx;
  const tags = context.tags;
  //const index = context.index;
  return (
    <div >
      { tags.map((tag,i) => {
        return (<TagChart key={i} index={i}/>)
      })}
    </div>
  )
}

export default TagList;
